import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { PermissionConst } from 'src/app/core/models/permission-const.model';
import { ProfessionModel } from 'src/app/core/models/profession.model';
import { RegistersService } from 'src/app/core/services/registers.service';
import { SessionManagerService } from 'src/app/core/services/session-manager.service';
import { ConfirmationModalComponent } from 'src/app/shared/renderers/components/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-professions-form',
  templateUrl: './professions-form.component.html',
  styleUrls: ['./professions-form.component.scss']
})
export class ProfessionsFormComponent implements OnInit {

  formGroup = this.fb.group({
    id: [],
    name: []
  });

  id!: number;
  loadingPage: boolean = false;
  submitting: boolean = false;
  submittingRemove: boolean = false;

  isRegister: boolean = true;
  removeButton: String = "Desativar";
  submitButton: String = "Salvar";

  button: boolean = false;

  fetchedProfessionData!: ProfessionModel;

  constructor(private fb: FormBuilder, private registersService: RegistersService, private activatedRoute: ActivatedRoute, private sessionManager: SessionManagerService, private toast: ToastrService, private router: Router, config: NgbModalConfig, private modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      if(this.id) {
        this.isRegister = false;
        this.fetchProfessionExistingData();
      }
    })
  }

  get canSave() {
    if(this.id) {
      return this.sessionManager.getUserPermission(PermissionConst.add_profession);
    } else {
      return this.sessionManager.getUserPermission(PermissionConst.change_profession);
    }
  }

  get canRemove() {
    return this.sessionManager.getUserPermission(PermissionConst.remove_profession);
  }

  cancelHandler() {
    this.router.navigate(['/dashboard/registers/professions'])
  }

  submitHandler() {
    this.submitting = true;
    this.formGroup.markAllAsTouched();

    let professionsData = this.formGroup.getRawValue() as ProfessionModel;
    if(this.isRegister) {
      if(this.formGroup.valid) {
        this.professionsRegister(professionsData);
      } else this.submitting = false;
    } else {
      this.professionsEdit(professionsData);
    }
  }

  removeHandler() {
    this.submittingRemove = true;
    const modalRef = this.modalService.open(ConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.text = "Deseja desativar esta profissão?";
    modalRef.result.then((result: boolean) => {
      if (result == true) {
        this.professionsRemove();
      } else this.submittingRemove = false;
    })
  }

  professionsRegister(professionData: ProfessionModel) {
    this.registersService.professionRegister(professionData).subscribe(response => {
      this.toast.success("Profissão criada com sucesso", "Sucesso", {
        closeButton: true,
      });
      this.router.navigate(['/dashboard/registers/professions']);
    }, (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
      this.submitting = false;
    });
  }

  professionsEdit(professionData: ProfessionModel) {
    professionData.is_active = true;
    this.registersService.professionEdit(professionData).subscribe(response => {
      this.toast.success("Profissão alterada com sucesso", "Sucesso", {
        closeButton: true,
      });
      this.router.navigate(['/dashboard/registers/professions']);
    }, (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
      this.submitting = false;
    });
  }

  professionsRemove() {
    this.registersService.professionRemove(this.id).subscribe(response => {
      this.toast.success("Profissão removida com sucesso", "Sucesso", {
        closeButton: true,
      });
      this.router.navigate(['/dashboard/registers/professions']);
    }, (error: HttpErrorResponse) => {
      this.submittingRemove = false;
      this.mapErrorResponse(error);
    })
  }

  fetchProfessionExistingData() {
    this.registersService.professionGet(this.id).subscribe(response => {
      this.fetchedProfessionData = response;
      if(this.fetchedProfessionData.is_active) {
        this.removeButton = "Desativar";
        this.submitButton = "Salvar";
        this.button = true;
      }
      else {
        this.button = false;
        this.submitButton = "Reativar";
        this.formGroup.disable();
      }
      this.formGroup.patchValue(this.fetchedProfessionData);
      this.loadingPage = false;
    }, (error: HttpErrorResponse) => {
      this.mapErrorResponse(error);
    })
  }

  mapErrorResponse(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["detail"]) {
      this.toast.error(errorResponse.error["detail"], "Erro", {
        closeButton: true,
      });
    }
    else {
      this.setFormErrors(errorResponse);
    }
  }

  setFormErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["name"]) this.formGroup.get("name")?.setErrors({ response: errorResponse.error['name'] });
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
      return true;
  }
}
